import React from "react";
import { Share2, Facebook, Twitter, MessageCircle } from "lucide-react";

const ShareSection = ({ content }) => {
  const c = content;
  if (!c) return null;
  const url = typeof window !== "undefined" ? window.location.origin : "";
  const text = encodeURIComponent("Check out Mini Golf Alabama - Find top indoor and outdoor putt putt courses!");

  return (
    <section className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
      <div className="bg-white rounded-2xl border border-gray-200 p-8 sm:p-10 shadow-sm flex flex-col md:flex-row items-start md:items-center justify-between gap-6">
        <div>
          <div className="flex items-center gap-3 mb-2">
            <Share2 className="w-6 h-6 text-[#e5243b]" />
            <h2 className="text-2xl font-black text-gray-900 tracking-tight">
              {c.shareTitle || "Share Mini Golf Alabama"}
            </h2>
          </div>
          <p className="text-gray-600 max-w-xl text-sm">{c.shareText}</p>
        </div>
        <div className="flex items-center gap-3">
          <a
            href={`https://www.facebook.com/sharer/sharer.php?u=${url}`}
            target="_blank"
            rel="noopener noreferrer"
            aria-label="Share on Facebook"
            className="w-10 h-10 flex items-center justify-center rounded-xl bg-blue-50 text-[#1e40af] hover:bg-[#1e40af] hover:text-white transition-all shadow-sm"
          >
            <Facebook className="w-5 h-5" />
          </a>
          <a
            href={`https://twitter.com/intent/tweet?text=${text}&url=${url}`}
            target="_blank"
            rel="noopener noreferrer"
            aria-label="Share on X"
            className="w-10 h-10 flex items-center justify-center rounded-xl bg-gray-100 text-gray-900 hover:bg-black hover:text-white transition-all shadow-sm"
          >
            <Twitter className="w-5 h-5" />
          </a>
          <a
            href={`https://wa.me/?text=${text}%20${url}`}
            target="_blank"
            rel="noopener noreferrer"
            aria-label="Share on WhatsApp"
            className="w-10 h-10 flex items-center justify-center rounded-xl bg-green-50 text-green-600 hover:bg-green-600 hover:text-white transition-all shadow-sm"
          >
            <MessageCircle className="w-5 h-5" />
          </a>
        </div>
      </div>
    </section>
  );
};

export default ShareSection;
